<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import { required } from "vuelidate/lib/validators";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Vue from "vue";
import axios from "axios";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import DatePicker from "vue2-datepicker";
Vue.component("v-select", vSelect);
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

// register the plugin on vue
import Toasted from "vue-toasted";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Departamento component
 */
export default {
  page: {
    title: "Ventas procesadas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Vuetable,
    VuetablePagination,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    DatePicker,
  },
  data() {
    return {
      
      userT : this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token}
      },
      metododeBusqueda: false,
      fecha_inicio: "",
      rangode_fecha: "",
      fecha_fin: "",
      repit: true,
      apiUrl: process.env.VUE_APP_URL,
      apiBase: process.env.VUE_APP_URL + "ventas/get_pagados",
      css: {
        table: {          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      formDepa: {
        nombre: "",
        descripcion: "",
        tiendaid: "",
        state: true,
        id: 0,
      },
      tiendasData: [],
      updating: false,
      estadotabla: true,
      title: "Ventas procesadas",
      itemst: [
        {
          text: "Caja",
          href: "/",
        },
        {
          text: "Ventas procesadas",
          active: true,
        },
      ],
      fields: [
        {
          name: "no_venta",
          title: "Venta",
          sortField: "no_venta",
          // width: "5%",
        },
        {
          name: "empleado",
          title: "Empleado",
          sortField: "empleado",
          // width: "10%",
        },
        // {
        //   name: "cliente_rapido",
        //   title: "Cliente Rapido",
        //   sortField: "cliente_rapido",
        //   // width: "10%",
        // },
        {
          name: "cliente",
          title: "Cliente",
          sortField: "cliente",
          // width: "15%",
        },
        {
          name: "fechac",
          title: "Fecha venta",
          sortField: "fechac",
          // width: "15%",
        },
        // {
        //   name: "fecha",
        //   title: "Fecha Vencimiento",
        //   sortField: "fecha",
        //   width: "15%",
        // },
        {
          name: "total",
          title: "Total",
          sortField: "total",
          // width: "15%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          // width: "10%",
        },
        {
          name: "estado_pago",
          title: "Estado pago",
          titleClass: "",
          dataClass: "text-muted",
          // width: "10%",
        },
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          // width: "10%",
        },
      ],
      searchType: [
        { nombre: "No. Venta", value: "no_venta" },
        { nombre: "Cliente", value: "cliente" },
        { nombre: "Empleado", value: "empleado" },
        { nombre: "Fecha venta", value: "fecha" },
      ],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,
      sortBy: "nombre_orden",
      sortDesc: false,
      searchLabel: { nombre: "Venta", value: "no_venta" },
      filterLabel: { nombre: "Venta", value: "no_venta" },
      showModalL: false, //Loading
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      data: [],
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 4,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
    };
  },
  validations: {
    formDepa: {
      nombre: {
        required,
        async isUnique(value) {
          if (value === "") return true;
          let response = await axios
            .get(
              this.apiUrl +
                "departamentos/nombre_repetido?nombre=" +
                value +
                "&id=" +
                this.formDepa.id +
                "&tienda=" +
                this.formDepa.tiendaid.id,{
            headers: { "x-token": this.userT.token}
          }
            )
            .catch(console.log);
          this.repit = response.data.msg;
          return response.data.msg;
        },
      },
      descripcion: { required },
      tiendaid: { required },
    },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    limpiarfiltro() {
      let me = this;
      me.fecha_inicio = "";
      me.fecha_fin = "";
    },
    separarfechas() {
      this.fecha_inicio = this.rangode_fecha[0];
      this.fecha_fin = this.rangode_fecha[1];
    },
    activarBuscadorFechas(search, index) {
      this.metododeBusqueda = index == 3 ? true : false;
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },
    validarFecha(fecha) {
      let hoy = moment(new Date());
      let vec = moment(fecha);
      if (hoy > vec) {
        return true;
      } else {
        return false;
      }
    },
    //Desactivar registro
    aprobar() {
      const { id, nombre } = this.formDepa;
      axios
        .put(process.env.VUE_APP_URL + "ordenes/autorizar", {
          id: id,
        },{
            headers: { "x-token": this.userT.token}
          })
        .then(() => {
          this.showModalD = false;
          Vue.toasted.error(nombre + "Orden Aprobado", this.options);
          this.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para desactivar", this.options);
        });
    },
    //Activar registro
    activate() {
      const { id, nombre } = this.formDepa;
      axios
        .put(process.env.VUE_APP_URL + "departamentos/activate", {
          id: id,
        },{
            headers: { "x-token": this.userT.token}
          })
        .then(() => {
          this.showModalA = false;
          Vue.toasted.info(nombre + " Activado", this.options);
          this.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para activar", this.options);
        });
    },

    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },
    async changeTypeDates() {
      await this.separarfechas();
      this.$refs.vuetable.refresh();
    },
    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.fecha_inicio = type.value == "fecha" ? "" : "";
      this.fecha_fin = type.value == "fecha" ? "" : "";
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          };
    },
    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.$reset();
          this.limpiarVariables();
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      this.formDepa.id = 0;
      this.formDepa.descripcion = "";
      this.formDepa.nombre = "";
      this.formDepa.descripcion = "";
      this.formDepa.tiendaid = null;
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalN = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },

    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action, data) {
      if (action == "aprobar-item") {
        this.formDepa.nombre = data.no_orden;
        this.formDepa.id = data.id;
        this.showModalD = true;
      }
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>

<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Activar -->
        <b-modal
          centered
          v-model="showModalA"
          title="Activar Departamento"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>
                    ¿Desea Activar el Departamento {{ this.formDepa.nombre }}?
                  </h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalA = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="activate">Activar</b-button>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Desactivar -->
        <b-modal
          centered
          v-model="showModalD"
          title="Aprobar"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>
                    ¿Desea aprobar el orden de compra No.:
                    {{ this.formDepa.nombre }}?
                  </h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalD = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="aprobar">Aprobar</b-button>
            </div>
          </form>
        </b-modal>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de ventas procesadas</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-2">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      @input="changePageSize()"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-2">
                <div
                  id="tickets-table_length"
                  class="dataTables_length text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <b-dropdown v-if="searchType" id="ddown1" size="sm">
                      <template v-slot:button-content>
                        {{ "Ordenar por: " + searchLabel.nombre }}
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                        v-for="(search, index) in searchType"
                        :key="index"
                        @click="
                          changeTypeSearch(search);
                          activarBuscadorFechas(search, index);
                          limpiarfiltro();
                        "
                        >{{ search.nombre }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-3" v-if="metododeBusqueda">
                <div
                  id="tickets-table_length"
                  class="dataTables_length text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <date-picker
                      v-model="rangode_fecha"
                      range
                      append-to-body
                      lang="en"
                      confirm
                      confirm-text="Aceptar"
                      @input="changeTypeDates()"
                    ></date-picker>
                  </label>
                </div>
              </div>

              <div
                class="col-sm-12 col-md-3 text-md-start"
                v-if="metododeBusqueda == false"
              >
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      v-model="search"
                      type="search"
                      @input="onFiltered()"
                      placeholder="Buscar..."
                      class="form-control form-control-sm"
                    ></b-form-input>
                  </label>
                </div>
              </div>

              <!-- <div class="col-sm-12 col-md-5">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <router-link
                      :to="{
                        name: 'nuevaVenta',
                      }"
                    >
                      <button
                        v-b-modal.modalSave
                        type="button"
                        class="btn btn-success btn-rounded mb-2 me-2"
                        @click="onActionClicked('new-item')"
                      >
                        <b>AGREGAR NUEVO</b>&nbsp;&nbsp;<i
                          class="bx bxs-plus-circle"
                        ></i>
                      </button>
                    </router-link>
                  </label>
                </div>
              </div> -->

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                ref="vuetable"
                class="table-divided order-with-arrow"
                :css="css.table"
                :api-url="apiBase"
                :reactive-api-url="true"
                :fields="fields"
                :per-page="perPage"
                :http-options="httpOptions"
                :query-params="makeQueryParams"
                pagination-path
                @vuetable:pagination-data="onPaginationData"
              >
                <div slot="actions" slot-scope="props">
                  <b-dropdown
                    text="Opciones"
                    variant="outline-primary"
                    size="sm"
                  >
                    <!-- Procesar ventas -->
                    <!-- <router-link
                      :to="{
                        name: 'vistaVenta',
                        params: { id: props.rowData.id },
                      }"
                    >
                      <b-dropdown-item-button
                        v-if="props.rowData.estado_venta"
                        tabindex="0"
                        v-b-tooltip.focus
                        title="Ver mas"
                        variant="outline-primary"
                        ><i class="bx bxs-show"></i>&nbsp;&nbsp;&nbsp;&nbsp;Procesar venta
                      
                      </b-dropdown-item-button>
                    </router-link> -->

                    <!-- Ver mas -->
                    <router-link
                      :to="{
                        name: 'verVentaProcesada',
                        params: { id: props.rowData.id },
                      }"
                    >
                      <b-dropdown-item-button
                        v-if="props.rowData.estado_venta"
                        tabindex="0"
                        v-b-tooltip.focus
                        title="Ver mas"
                        variant="outline-primary"
                        ><i class="bx bxs-show"></i>&nbsp;&nbsp;&nbsp;&nbsp;Ver
                        más
                      </b-dropdown-item-button>
                    </router-link>
                    <!-- Imprimir -->
                    <!-- <router-link
                      :to="{
                        name: 'imprimirVenta',
                        params: { id: props.rowData.id },
                      }"
                    >
                      <b-dropdown-item-button
                        v-if="props.rowData.estado_venta"
                        tabindex="0"
                        title="Imprimir"
                        variant="outline-secondary"
                        ><i class="bx bx-printer"></i
                        >&nbsp;&nbsp;&nbsp;&nbsp;Imprimir
                      </b-dropdown-item-button>
                    </router-link> -->
                  </b-dropdown>
                </div>

                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_venta == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>

                <div slot="estado_pago" slot-scope="props">
                  <h5 v-if="props.rowData.estado_pagado == true">
                    <span class="badge bg-primary ms-1"
                      ><strong>PAGADO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-warning ms-1"
                      ><strong>PENDIENTE DE PAGO</strong></span
                    >
                  </h5>
                </div>
                <div slot="empleado" slot-scope="props">
                  {{ props.rowData.user.empleado.persona.nombre_persona }}
                  {{ props.rowData.user.empleado.persona.apellido_persona }}
                </div>
                <div
                  slot="cliente"
                  slot-scope="props"
                  v-if="props.rowData.cliente"
                >
                  {{ props.rowData.cliente.persona.nombre_persona }}
                  {{ props.rowData.cliente.persona.apellido_persona }}
                </div>
                <div
                  slot="cliente_rapido"
                  slot-scope="props"
                  v-if="props.rowData.cliente_rapido"
                >
                  {{ props.rowData.cliente_rapido }}
                </div>

                <div slot="fechac" slot-scope="props">
                  {{ showDate(props.rowData.fecha_cotizacion) }}
                </div>
                <div slot="fecha" slot-scope="props">
                  {{ showDate(props.rowData.fecha_vencimiento) }}
                  <br />
                  <h6 class="red">
                    {{
                      validarFecha(props.rowData.fecha_vencimiento)
                        ? "Vencida"
                        : ""
                    }}
                  </h6>
                </div>
                <div slot="total" slot-scope="props">
                  {{ money(props.rowData.total) }}
                </div>
              </vuetable>
              <div style="padding-top: 10px">
                <vuetable-pagination
                  ref="pagination"
                  :css="css.pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
